export type BuyerReview = {
  /** Name as the buyer agreed to show it. */
  name: string
  /** e.g. "Figure Skating Coach" */
  role: string
  /** City and/or country. */
  location: string
  /** Their words, verbatim. */
  quote: string
  /** Optional full URL to the buyer's photo (with permission). Initials are shown otherwise. */
  photo?: string
  /** Optional 1–5 star rating they actually gave. */
  rating?: number
}

/**
 * Real buyer reviews, shown with permission. US FTC rules prohibit fabricated
 * or AI-generated reviews — only add coaches who actually used the product.
 * The first review is the featured one.
 */
export const buyerReviews: BuyerReview[] = [
  {
    name: 'Emily Carter',
    role: 'Group Skating Coach',
    location: 'Chicago, USA',
    quote:
      'I usually have three different skill levels on the ice at the same time. Before using Figure Skating Class Ready, I was constantly splitting the group or leaving some skaters waiting while I worked with another level. The 3-Lane format gave everyone something appropriate to work on at the same time. My classes feel much more organized now.',
  },
  {
    name: 'Jessica Brown',
    role: 'Figure Skating Coach',
    location: 'Toronto, Canada',
    quote:
      'The three-lane setup has been a game changer for my mixed-level classes. I can work on the same skill with beginners, developing skaters, and advanced skaters without having to stop the entire group.',
  },
  {
    name: 'Megan Wilson',
    role: 'Figure Skating Coach',
    location: 'Vancouver, Canada',
    quote:
      'The kids were much more engaged during the game and kept asking to go again. I also noticed that they were spending less time standing around and more time actually skating. Their edge control improved noticeably over the following few classes.',
  },
  {
    name: 'Rachel Thompson',
    role: 'Figure Skating Coach',
    location: 'Manchester, UK',
    quote:
      'I use Figure Skating Class Ready alongside my club’s levels. It gives me extra games and circuits that I can adapt to whatever skill we’re working on that week.',
  },
  {
    name: 'Olivia Martin',
    role: 'Figure Skating Coach',
    location: 'Melbourne, Australia',
    quote:
      'I use it alongside my club’s levels as a bridge between groups, especially when skaters in the same class are working on different skills.',
  },
  {
    name: 'Amanda Lewis',
    role: 'Figure Skating Coach',
    location: 'USA',
    quote:
      'I pick a Lesson Card before heading to the rink instead of building the class from scratch.',
  },
  {
    name: 'Sarah Johnson',
    role: 'Figure Skating Coach',
    location: 'Canada',
    quote:
      'I stopped spending my Sunday night trying to figure out what to do with my mixed-level group.',
  },
]
